import { TossPaymentFailResult, TossPaymentSuccessResult } from './types';

/** success URL 쿼리 파라미터 파싱 */
export function parseSuccessResult(
  searchParams: URLSearchParams,
): TossPaymentSuccessResult {
  return {
    paymentType: searchParams.get('paymentType') ?? '',
    paymentKey: searchParams.get('paymentKey') ?? '',
    orderId: searchParams.get('orderId') ?? '',
    amount: Number(searchParams.get('amount') ?? 0),
  };
}

/** fail URL 쿼리 파라미터 파싱 */
export function parseFailResult(
  searchParams: URLSearchParams,
): TossPaymentFailResult {
  return {
    code: searchParams.get('code') ?? '',
    message: searchParams.get('message') ?? '',
    orderId: searchParams.get('orderId'),
  };
}
